import * as i0 from "@angular/core";
/**
 * Consolidated logging service to log and send data to server for further processing
 */
export class LoggerService {
    constructor() { }
    error(error) {
        console.error(`Error ocurred: ${error.message}`);
        // ToDo send data to server for processing/troubleshooting
    }
}
LoggerService.ngInjectableDef = i0.defineInjectable({ factory: function LoggerService_Factory() { return new LoggerService(); }, token: LoggerService, providedIn: "root" });
